import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.668 1a.335.335 0 0 0-.336.332V2c0 .184.152.332.336.332h.664A.335.335 0 0 0 4.668 2v-.668A.335.335 0 0 0 4.332 1Zm0 2.332a.34.34 0 0 0-.336.336v.664c0 .184.152.336.336.336h.664a.34.34 0 0 0 .336-.336v-.664a.34.34 0 0 0-.336-.336Zm0 2.336A.335.335 0 0 0 3.332 6v.668c0 .184.152.332.336.332h.664a.335.335 0 0 0 .336-.332V6a.335.335 0 0 0-.336-.332Zm0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#000","fill-opacity":"1"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }